import { useMemo } from "react";
import { useParams } from "react-router";

import { useDynamicViewSchema } from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider.tsx";
import { useListSchema } from "src/pages/Blacklists/useListSchema.ts";
import { ClientSchemaBlacklist } from "src/types/clientSchema";
import { Property } from "src/types/property";

export type UseEditablePropertiesResult = {
  listSchema: ClientSchemaBlacklist | undefined;

  editPropertiesCodes: string[] | undefined | null;

  editProperties: Property[] | null;

  disable: boolean;
};

export const useEditableProperties = (): UseEditablePropertiesResult => {
  const params = useParams<{ code: string }>();
  const { blacklists } = useDynamicViewSchema();
  const { listSchema } = useListSchema();

  const editPropertiesCodes = useMemo(
    () => blacklists?.find((b) => b.blacklistCode === params.code)?.editableProperties,
    [blacklists, params.code]
  );

  const editProperties = useMemo<Property[] | null>(() => {
    if (!editPropertiesCodes || !listSchema) return null;
    return listSchema.properties.filter((property) =>
      editPropertiesCodes.some((code) => code === property.code)
    );
  }, [editPropertiesCodes, listSchema]);

  const disable = editProperties !== null && editProperties.length === 0;

  return { listSchema, editPropertiesCodes, editProperties, disable };
};
